import {CustomerAccountLinksComponent} from './customer-account-links';

export const SHARED_CUSTOMER_ACCOUNT_COMPONENTS = [
    CustomerAccountLinksComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/customer-account/index.ts